import { render, staticRenderFns } from "./Backbound.vue?vue&type=template&id=5f1ce9ac&scoped=true&"
import script from "./Backbound.vue?vue&type=script&lang=js&"
export * from "./Backbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1ce9ac",
  null
  
)

export default component.exports